module.exports = __webpack_public_path__ + "static/img/05ko.279b57b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/05ko.jpg
// module id = xTJk
// module chunks = 0